
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Ernst K., 84 ans, décédé le 20 octobre 2020</b>
    <br />
    <br />
    <i>Sa femme raconte:</i>
    <br />
    <p>
  «Mon mari et moi avons toujours respecté les gestes barrières. Pourtant, j'ai
  été infectée. Je ne sais pas pourquoi ni où cela s'est passé. Mais je ne me
  pose pas ces questions. Le virus est déjà assez difficile à vivre comme cela.
  Je ne veux plus en entendre parler. J’ai fait très attention à mon mari, le
  médecin nous l’avait recommandé. Ernst était en effet affaibli par un problème
  au cœur. Il devait être protégé du coronavirus. Malheureusement le scénario du
  pire s’est déroulé. J’ai de la peine à le vivre. Mais je suis bien entourée.
  Un proche vient me rendre visite. Je me sens soutenue. Je comprends que les
  gens veuillent vivre comme avant, sans restriction de liberté. La vie
  continue, c’est certain. Ernst avait déjà un certain âge. Nous avions
  conscience du danger. Mais, lorsque cela nous arrive, cela fait quand même
  très mal. Mon mari était un homme bon. Il était maître boulanger. Il a formé
  beaucoup d’apprentis.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;